(() => {
  if (window.gfFullscreenGalleryLoaded) return;
  window.gfFullscreenGalleryLoaded = true;
  const initialized = new WeakSet();
  const init = () => document.querySelectorAll('product-info.gf-mobile-product').forEach((section) => {
    const modal = document.getElementById(`ProductModal-${section.dataset.section}`);
    const template = section.querySelector('template[data-gf-gallery-controls]');
    const content = modal?.querySelector('.product-media-modal__content');
    if (!modal || !content || !template || initialized.has(modal)) return;
    initialized.add(modal);
    const controller = new AbortController();
    const signal = controller.signal;
    const controls = template.content.firstElementChild.cloneNode(true);
    modal.querySelector('[role="dialog"]').appendChild(controls);
    const previous = controls.querySelector('[data-gf-prev]');
    const next = controls.querySelector('[data-gf-next]');
    const counter = controls.querySelector('[data-gf-counter]');
    const zoom = controls.querySelector('[data-gf-zoom]');
    const images = () => [...content.querySelectorAll(':scope > img[data-media-id]')];
    const active = () => images().find((item) => item.classList.contains('active'));
    const viewportZoomed = () => (window.visualViewport?.scale || 1) > 1.05;
    let zoomed = false;
    let returnScroll = null;
    let gesture = null;
    let multiTouch = false;
    const pointers = new Set();
    const setZoom = (value) => {
      zoomed = value;
      modal.classList.toggle('gf-gallery-zoomed', value);
      zoom.setAttribute('aria-pressed', String(value));
      zoom.textContent = value ? zoom.dataset.zoomOut : zoom.dataset.zoomIn;
      content.scrollTo({ left: 0, top: 0, behavior: 'instant' });
    };
    const sync = () => {
      const list = images();
      const index = list.indexOf(active());
      const visible = modal.hasAttribute('open') && index >= 0;
      if (controls.hidden === visible) controls.hidden = !visible;
      if (modal.classList.contains('gf-image-active') !== visible) modal.classList.toggle('gf-image-active', visible);
      const text = `${index + 1} / ${list.length}`;
      if (counter.textContent !== text) counter.textContent = text;
      previous.disabled = index <= 0;
      next.disabled = index < 0 || index >= list.length - 1;
      if (!modal.hasAttribute('open')) {
        if (zoomed) setZoom(false);
        gesture = null; pointers.clear(); multiTouch = false;
      }
    };
    const navigate = (direction) => {
      const list = images();
      const index = list.indexOf(active());
      const target = list[index + direction];
      if (index < 0 || !target) return;
      setZoom(false);
      list.forEach((item) => item.classList.toggle('active', item === target));
      const gallery = section.querySelector('.product__media-list');
      const mediaId = target.dataset.mediaId;
      const slide = [...(gallery?.querySelectorAll('[data-media-id]') || [])].find((item) => item.dataset.mediaId === `${section.dataset.section}-${mediaId}` || item.dataset.mediaId === mediaId);
      if (gallery && slide) {
        gallery.querySelectorAll(':scope > [data-media-id]').forEach((item) => item.classList.toggle('is-active', item === slide));
        const mediaGallery = section.querySelector('media-gallery');
        const thumbnail = [...(mediaGallery?.querySelectorAll('[data-target]') || [])].find((item) => item.dataset.target === slide.dataset.mediaId);
        if (thumbnail) mediaGallery.setActiveThumbnail?.(thumbnail);
        const opener = slide.querySelector('.product__media-toggle');
        if (opener) modal.openedBy = opener;
        const left = slide.offsetLeft - gallery.firstElementChild.offsetLeft;
        gallery.scrollTo({ left, behavior: 'instant' });
        if (returnScroll) returnScroll.left = left;
        gallery.dispatchEvent(new CustomEvent('gf:gallery-change', { detail: { left } }));
      }
      sync();
    };
    previous.addEventListener('click', () => navigate(-1), { signal });
    next.addEventListener('click', () => navigate(1), { signal });
    zoom.addEventListener('click', () => setZoom(!zoomed), { signal });
    section.querySelector('.product__media-list')?.addEventListener('click', (event) => {
      if (!event.target.closest('modal-opener')) return;
      returnScroll = { x: window.scrollX, y: window.scrollY, left: section.querySelector('.product__media-list').scrollLeft };
    }, { capture: true, signal });
    document.body.addEventListener('modalClosed', () => {
      if (!returnScroll || !modal.hasAttribute('open')) return;
      const state = returnScroll;
      returnScroll = null;
      requestAnimationFrame(() => {
        section.querySelector('.product__media-list')?.scrollTo({ left: state.left, behavior: 'instant' });
        window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
      });
    }, { signal });
    modal.addEventListener('pointerup', (event) => {
      if (modal.classList.contains('gf-image-active') && event.target.closest('.product-media-modal__content,.gf-gallery-controls')) {
        if (event.target.closest('.product-media-modal__content')) end(event);
        event.stopImmediatePropagation();
      }
    }, { capture: true, signal });
    content.addEventListener('pointerdown', (event) => {
      if (!active()) return;
      pointers.add(event.pointerId);
      if (pointers.size > 1) { multiTouch = true; gesture = null; return; }
      if (zoomed && event.pointerType === 'mouse') {
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, pan: true, left: content.scrollLeft, top: content.scrollTop };
        content.setPointerCapture(event.pointerId);
        return;
      }
      if (zoomed || viewportZoomed()) return;
      multiTouch = false;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, started: Date.now() };
      if (event.pointerType === 'mouse') content.setPointerCapture(event.pointerId);
    }, { passive: true, signal });
    const end = (event) => {
      pointers.delete(event.pointerId);
      if (event.type === 'pointercancel') { gesture = null; return; }
      if (!gesture || gesture.id !== event.pointerId) return;
      if (gesture.pan) { gesture = null; return; }
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      const elapsed = Date.now() - gesture.started;
      gesture = null;
      if (!zoomed && !viewportZoomed() && !multiTouch && Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.35 && elapsed < 1200) navigate(dx < 0 ? 1 : -1);
    };
    content.addEventListener('pointermove', (event) => {
      if (!gesture?.pan || gesture.id !== event.pointerId) return;
      content.scrollTo({ left: gesture.left - event.clientX + gesture.x, top: gesture.top - event.clientY + gesture.y, behavior: 'instant' });
    }, { passive: true, signal });
    content.addEventListener('pointercancel', end, { signal });
    content.addEventListener('dragstart', (event) => { if (event.target.tagName === 'IMG') event.preventDefault(); }, { signal });
    modal.addEventListener('keydown', (event) => {
      if (!modal.hasAttribute('open') || !active()) return;
      if (event.key === 'Tab') {
        const focusable = [...modal.querySelectorAll('button, [tabindex]')].filter((item) => item.tabIndex >= 0 && !item.disabled && item.getClientRects().length);
        const index = focusable.indexOf(document.activeElement);
        const targetIndex = index < 0 ? (event.shiftKey ? focusable.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
        const target = focusable[targetIndex];
        if (target) { event.preventDefault(); event.stopPropagation(); target.focus(); }
        return;
      }
      if (zoomed || viewportZoomed()) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); navigate(event.key === 'ArrowRight' ? 1 : -1);
      }
    }, { signal });
    const observer = new MutationObserver(sync);
    observer.observe(modal, { attributes: true, subtree: true, childList: true, attributeFilter: ['open', 'class'] });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail?.sectionId !== section.dataset.section) return;
      observer.disconnect(); controller.abort(); controls.remove(); initialized.delete(modal);
    }, { signal });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
